import React from 'react';

export default class Jumbotron extends React.Component {
  render() {
    // eslint-disable-next-line react/prop-types
    return <div className="jumbotron bg-dark" >
    <div className="container">
    <div className="row">
    <div className="col-md-3 col-sm-12">
    <img src="./assets/img/logoRhx.png" width="138" height="67"/>
    </div>
    <div className="col-9 d-none d-md-block">
    <h2 className="text-white">RHX ImapSync</h2>
    <p className="lead text-white">Tramite questa applicazione sarai in grado di sincronizzare la tua posta dal tuo gestore a RHX</p>
    </div>
   </div>
   </div>
   </div>;
  }
}
